import axios from 'axios';
import React from 'react';
import { StatusesModel } from 'src/models/services/statuses';
import { API_url } from '../api.setup';
import { enqueueSnackbar } from 'notistack';

const API_Controller = '/status';

export const StatusesService = {
  getAllData: async () => {
    try {
      const response = await axios.get(`${API_url}${API_Controller}/getall`);
      return response.data as StatusesModel[];
    } catch (error) {
      throw error;
    }
  },

  getStatus: async (statusId) => {
    try {
      const response = await axios.get(`${API_url}${API_Controller}/get?id=${statusId}`);
      return response.data as StatusesModel;
    } catch (error) {
      throw error;
    }
  },

  addData: async (dataToAdd: StatusesModel) => {
    try {
      const response = await axios.post(
        `${API_url}${API_Controller}`,
        dataToAdd
      );
      enqueueSnackbar(`Status ${dataToAdd.name} Added Successfully`, {
        variant: 'success'
      });
      return response.data as StatusesModel[];
    } catch (error) {
      throw error;
    }
  },

  editData: async (dataToUpdate: StatusesModel) => {
    try {
      const respons = await axios.put(
        `${API_url}${API_Controller}/update`,
        dataToUpdate
      );
      enqueueSnackbar(`Status ${dataToUpdate.name} Added Successfully`, {
        variant: 'success'
      });

      return respons.data as StatusesModel[];
    } catch (error) {
      throw error;
    }
  },

  deleteData: async (deleteId, data) => {
    try {
      const response = await axios.delete(
        `${API_url}${API_Controller}/delete?id=${deleteId}`
      );
      enqueueSnackbar(`Status deleted Successfully`, {
        variant: 'success'
      });
      return response.data as StatusesModel[];
    } catch (error) {
      enqueueSnackbar(`Status cannot be deleted. Assigned to Booking`, {
        variant: 'error'
      });
      throw error;
    }
  }
};
